import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../APIRoute";
import { apiCall } from "../../AxiosService";
import { apiResponse } from "../../APIResponse";

export const ChargesByWorkflow = createAsyncThunk(
  "ChargesByWorkflow",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "GET",
          url:
            API_URL.BASEURL +
            API_URL.BILLING_COST_MANAGEMENT.GET_CHARGE_BY_WORKFLOW +
            `?startdate=${data?.startdate}&enddate=${data?.enddate}&timezone=${data?.timezone}`,
          // body: data,
        },
        false
      );
      let response = apiResponse(false, resData);

      return response;
    } catch (error) { }
  }
);
export const ChargesByMachine = createAsyncThunk(
  "ChargesByMachine",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "GET",
          url:
            API_URL.BASEURL +
            API_URL.BILLING_COST_MANAGEMENT.GET_CHARGE_BY_MACHINE +
            `?startdate=${data?.startdate}&enddate=${data?.enddate}&workflowid=${data?.workflowid}&timezone=${data?.timezone}`,
          // body: data,
        },
        false
      );
      let response = apiResponse(false, resData);

      return response;
    } catch (error) { }
  }
);
export const ChargesByMachineMain = createAsyncThunk(
  "ChargesByMachineMain",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "GET",
          url:
            API_URL.BASEURL +
            API_URL.BILLING_COST_MANAGEMENT.GET_CHARGE_BY_MACHINE +
            `?startdate=${data?.startdate}&enddate=${data?.enddate}&timezone=${data?.timezone}`,
          // body: data,
        },
        false
      );
      let response = apiResponse(false, resData);

      return response;
    } catch (error) { }
  }
);
export const ChargesListWorkflowByMachine = createAsyncThunk(
  "ChargesListWorkflowByMachine",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "GET",
          url:
            API_URL.BASEURL +
            API_URL.BILLING_COST_MANAGEMENT
              .GET_CHARGE_LIST_WORKFLOW_BY_MACHINE +
            `?startdate=${data?.startdate}&enddate=${data?.enddate}&machineid=${data?.machineid}&timezone=${data?.timezone}`,
          // body: data,
        },
        false
      );
      let response = apiResponse(false, resData);

      return response;
    } catch (error) { }
  }
);

export const ChargesListInvoice = createAsyncThunk(
  "ChargesListInvoice",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "GET",
          url:
            API_URL.BASEURL +
            API_URL.BILLING_COST_MANAGEMENT.GET_INVOICE_LIST +
            `?startdate=${data?.startdate}&enddate=${data?.enddate}&timezone=${data?.timezone}`,
          // body: data,
        },
        false
      );
      let response = apiResponse(false, resData);

      return response;
    } catch (error) { }
  }
);

const initialState = {
  ChargesByWorkflowData: {
    data: null,
    error: null,
  },
  ChargesByMachineData: {
    data: null,
    error: null,
  },
  ChargesByMachineMainData: {
    data: null,
    error: null,
  },
  ChargesListWorkflowByMachineData: {
    data: null,
    error: null,
  },
  ChargesListInvoiceData: {
    data: null,
    error: null,
  },
};

const CostManagementSlice = createSlice({
  name: "COSTMANAGEMENT",
  initialState,
  reducers: {
    // setLoader: (state, action) => {
    //   state.isLoading = action.payload;
    // },
    //   setWorkFlowGetListData: (state) => {
    //     state.WorkFlowGetListData.data = null;
    //   },
    //   setGetWorkFlowByID: (state) => {
    //     state.GetWorkFlowByIDData.data = null;
    //   },
  },

  extraReducers: (builder) => {
    builder
      .addCase(ChargesByWorkflow.fulfilled, (state, action) => {
        state.ChargesByWorkflowData.data = action.payload;
      })
      .addCase(ChargesByWorkflow.rejected, (state, action) => {
        state.ChargesByWorkflowData.error = action.error.message;
      })
      .addCase(ChargesByMachine.fulfilled, (state, action) => {
        state.ChargesByMachineData.data = action.payload;
      })
      .addCase(ChargesByMachine.rejected, (state, action) => {
        state.ChargesByMachineData.error = action.error.message;
      })
      .addCase(ChargesByMachineMain.fulfilled, (state, action) => {
        state.ChargesByMachineMainData.data = action.payload;
      })
      .addCase(ChargesByMachineMain.rejected, (state, action) => {
        state.ChargesByMachineMainData.error = action.error.message;
      })
      .addCase(ChargesListWorkflowByMachine.fulfilled, (state, action) => {
        state.ChargesListWorkflowByMachineData.data = action.payload;
      })
      .addCase(ChargesListWorkflowByMachine.rejected, (state, action) => {
        state.ChargesListWorkflowByMachineData.error = action.error.message;
      })
      .addCase(ChargesListInvoice.fulfilled, (state, action) => {
        state.ChargesListInvoiceData.data = action.payload;
      })
      .addCase(ChargesListInvoice.rejected, (state, action) => {
        state.ChargesListInvoiceData.error = action.error.message;
      });
  },
});

// export const { setLoader } = CartSlice.actions;
export default CostManagementSlice.reducer;
